import classnames from "classnames";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import CollapseImg from "../../../assets/icons/collapse.png";
// import Search from "../../../assets/icons/search.png"
import LogoAdmin from "../../../assets/images/Logo-admin.png";
import MedAppGuiaV1  from "../../../assets/docs/MedAppGuiaV1.js";
import Logo from "../../../assets/images/logo.png";
import { UpdateUserPreferences } from "../../../redux/actions/account-action-types";
import {
	changeLanguage, 
} from "../../../redux/actions/user-action-types";
import translator from "../../../utilities/translator";

function Header({ className, toggleSidebar }) {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.session);
	const currentLanguage = useSelector((state) => state.session?.userPreferences?.language);
	const { userInfo, userPreferences } = user;
	//const sessionDownloads = useSelector((state) => state.session.sessionDownloads??[]);
	const [sessionDownloads, setSessionDownloads] = useState([]);

	const [notifications, setNotifications] = useState(false);
	const [userDropDown, setUserDropDown] = useState(false);
	const [showDownloadManager, setShowDownloadManager] = useState(false);
	const [downloadManagerWorker, setDownloadManagerWorker] = useState(null);
	const guideText = MedAppGuiaV1;

	React.useEffect((e) => {
		setDownloadManagerWorker(!!window.SharedWorker ? new SharedWorker("/worklet/DownloadManagerWorker.js") : null);
	},[]);

	const downloadManagerWorkerCallBack = React.useCallback((e) => {
		let messageResult = e?.data;
		switch (messageResult?.type) {
			case 'list':
				for (let index = 0; index < messageResult.data?.length; index++) {
					const element = messageResult.data[index];
					if(element.obj){
						element.link = window.URL.createObjectURL(element?.obj);
					}
				}
				setSessionDownloads(messageResult.data);
				if(messageResult?.data?.length === 0){
					setShowDownloadManager(false);
				}
				if(messageResult?.data?.length === 1){
					setShowDownloadManager(true);
				}
				break;
			default:
				break;
		}
	}, [])

	useEffect(()=> {
		if(downloadManagerWorker){
			downloadManagerWorker.port.postMessage({ type: 'list' });
		}
	}, [downloadManagerWorker]);

	useEffect(()=> {
		if(downloadManagerWorker){
			downloadManagerWorker.port.onmessage = downloadManagerWorkerCallBack;
			//downloadManagerWorker.postMessage({ type: 'length'});
		}
	}, [downloadManagerWorker]);

	const imageDownloadFn = React.useCallback((e) => {
		if(downloadManagerWorker){
			if(sessionDownloads === 0){
				setShowDownloadManager(true);
			}
			downloadManagerWorker.port.postMessage({ type: 'process', data: e?.detail});
			downloadManagerWorker.port.postMessage({ type: 'list' });
		}
	}, [downloadManagerWorker, sessionDownloads]);


	React.useEffect(() => {
		document.addEventListener("medapp_image_download", imageDownloadFn);
		return () => {
			document?.removeEventListener('medapp_image_download', imageDownloadFn);
		}
	}, [downloadManagerWorker]);

	function renderLogo() {
		if (!className) {
			return (
				<a
					className="sidebar-brand d-flex align-items-center justify-content-center"
					href="/exam-ref-list"
				>
					<img src={LogoAdmin} alt="adminlogo" />
				</a>
			);
		} else {
			return (
				<a
					className="sidebar-brand d-flex align-items-center justify-content-center"
					href="/exam-ref-list"
				>
					<img src={Logo} alt="userlogo" />
				</a>
			);
		}
	}

	return (
		<nav
			className="navbar navbar-expand navbar-light bg-customdark shadow navbar-default"
			style={{ height: "40px" }}
		>
			{renderLogo()}
			<button
				id="sidebarToggleTop"
				className="btn btn-link rounded-circle mx-3 "
				onClick={toggleSidebar}
			>
				<img src={CollapseImg} alt="collapse" />
			</button>
			<ul className="navbar-nav ml-auto mr-3">
				<li className="nav-item"></li>
				<li className="nav-item dropdown no-arrow  visibleon-small">
					<button
						className="btn btn-link nav-link dropdown-toggle"
						id="searchDropdown"
						data-toggle="dropdown"
						aria-haspopup="true"
						aria-expanded="false"
					>
						<i className="fa fa-search fa-fw" />
					</button>
					<div
						className="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in"
						aria-labelledby="searchDropdown"
					>
						<form className=" mr-auto w-100 navbar-search">
							<div className="input-group">
								<input
									type="text"
									className="form-control bg-light border-0 small "
									placeholder="Search for..."
									aria-label="Search"
									aria-describedby="basic-addon2"
								/>
								<i className="fa fa-search fa-sm text-white" />
							</div>
							<div className="btn action-btn orange-base" type="button">
								<div className="input-group-append"></div>
							</div>
						</form>
					</div>
				</li>
				<li className="nav-item">
					<button
						className="btn btn-link nav-link"
						onClick={async () => setShowDownloadManager(!showDownloadManager)}
					>
						<div className="text-center rounded-circle" style={{ fontSize: "26px", float: 'left', color: sessionDownloads?.length > 0 ? "#E78E4B" : '#ccc'}}>
							<i className="zmdi zmdi-download"></i>
						</div>
					</button>
					<div style={{ display: showDownloadManager ? 'block' : 'none', 
							position: 'absolute', top: '38px', 
							border: '1px solid green', zIndex: '1001',
							background: 'white', padding: '4px', 
							borderRadius: '3px', right: '250px', width: '300px'}} >
						<a href="/dcm-download" target="_blank"><h5>Download List</h5></a>
						
						<ul id="#downloadManagerDCM" style={{ listStyle: 'none', padding: '0'}}>
							{ Array.isArray(sessionDownloads) && sessionDownloads?.map(item => {
								return <li style={{ position: 'relative'}}>
									<div style={{ color: 'black'}}>{ item.name}</div>
									<div style={{ position: 'relative', background: 'grey'}}>
										<div style={{ background: 'orange', height: '20px', width: '' + item.percent + '%'}}>
											
										</div>
										<div style={{ position: 'absolute', top: '0', color: 'white', width: '100%', textAlign: 'center' }}>
										 { item.percent === 0 && (
											<div>
												Waiting for server
												<div style={{ 
													animation: 'spinner-border 1000ms infinite linear', 
													width: 'fit-content' , 
													float: 'right',
													}}>
													<i className="zmdi zmdi-refresh" ></i>
												</div>
												</div>
											)}
										 { item.percent !== 100 && (
											<div>{ item.percent + '%'} - Sec: { item.seconds} - Kpbs: { item.kbps}</div>
											)}
											{ item?.link?.length > 0 && <a style={{ color: 'white' }} target="_blank" rel="noreferrer" download={item.name+'.zip'} href={item.link} onClick={(e) => {
													downloadManagerWorker?.port?.postMessage({ type: 'remove', data: { uri: item.uri }});
												}}>Download</a>}</div>
									</div>
									<i style={{ position: 'absolute', top: '0', right: '5px' }} className="zmdi zmdi-delete" onClick={(e) => {
										downloadManagerWorker?.port?.postMessage({ type: 'remove', data: { uri: item.uri }});
									}}></i>
								</li>;
							})}
						</ul>
					</div>
				</li>
				
				<ul className="loc-items my-0 ml-0 pl-0 list-unstyled mt-3">
					<li className="d-flex flex-wrap ">
						<div className="custm-select">
							<select
								id="languageSelector"
								onChange={async (e) => {
									dispatch(changeLanguage(e.target.value));
									dispatch(
										UpdateUserPreferences({ data: {
											language: e.target.value,
										}})
									);
								}}
								value={currentLanguage}
							>
								<option value="EN">EN</option>
								<option value="PT">PT</option>
							</select>
						</div>
					</li>
				</ul>

				<li
					className={classnames("nav-item dropdown no-arrow", {
						open: userDropDown,
						show: userDropDown,
					})}
				>
					<span
						onClick={async () => setUserDropDown(!userDropDown)}
						className="nav-link dropdown-toggle"
						id="userDropdown"
						role="button"
						data-toggle="dropdown"
						aria-haspopup="true"
						aria-expanded={userDropDown}
					>
						<div className="text-center rounded-circle" style={{ fontSize: "26px", float: 'left', color: "#E78E4B" }}>
							<i className="zmdi zmdi-account-circle"></i>
						</div>
						<span className="ml-2 d-none d-lg-inline profiler-name small">
							{ (userInfo?.userName??'') + " "}
						</span>
					</span>
					<div
						className={classnames(
							"dropdown-menu dropdown-menu-right shadow animated--grow-in profile-set",
							{ show: userDropDown }
						)}
						aria-labelledby="userDropdown"
						style={{
							zIndex: '1000000'
						}}
					>
						<Link to="/configuration/personal">
							<span className="dropdown-item" style={{ cursor: "pointer" }}>
								{translator(currentLanguage, 'configuration')}
							</span>
						</Link>
						<a href="http://startcontrol.com/imedical/" target="_blank">
							<span className="dropdown-item" style={{ cursor: "pointer" }}>
								{translator(currentLanguage, 'support')}
							</span>
						</a>
						<span
							className="dropdown-item"
							data-toggle="modal"
							data-target="#logoutModal"
							style={{ cursor: "pointer" }}
						>
							Logout
						</span>
					</div>
				</li>
			</ul>
		</nav>
	);
}

export default Header;
